<template>
  <div class="m-3">
    <component
      :title="slideoverTitle"
      :is="slideoverComponent"
      :visible="slideoverVisible"
      v-bind="slideoverProps"
      v-on:toggle-slideover="hideSlideover"
    />

    <div class="flex flex1 flex-row justify-end">
      <div class="relative inline-block text-left z-10" v-if="canShowActions">
        <div>
          <span class="rounded-md shadow-sm">
            <Button
              v-on:click-handler="toggleActionsMenu"
              class="btn btn-primary btn-small relative z-10"
            >
              Actions
              <icon
                set="solid"
                name="chevron-down"
                class="-mr-1 ml-2 h-5 w-5"
              />
            </Button>
            <button
              v-if="showActionsMenu"
              @click="showActionsMenu = false"
              tabindex="-1"
              class="fixed inset-0 w-full h-full bg-black opacity-50 cursor-default"
            ></button>
          </span>
        </div>

        <transition
          enter-active-class="ease-out duration-100"
          enter-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="ease-in duration-75"
          leave-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          <div
            v-if="showActionsMenu"
            class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg"
          >
            <div class="rounded-md bg-white shadow-xs">
              <div
                class="py-1"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <button
                  class="block w-full px-4 py-2 text-sm leading-5 text-gray-700 text-left"
                  role="menuitem"
                  @click="
                    showOrderMiscEditSlideover();
                    toggleActionsMenu();
                  "
                >
                  Edit Misc
                </button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="pt-2 grid grid-flow-col grid-cols-3 gap-4">
      <div class="flex flex-col col-span-1 gap-y-3">
        <div>
          Sales Rep:
          {{ order.RefName }}
        </div>

        <div>Block Shipping Reason: {{ order.LocalSortText4 }}</div>

        <div>Bad Address Status: {{ order.LocalSortText5 }}</div>

        <div>
          Customer IP:
          <span class="font-mono"> {{ order.CustomerIP }} </span>
        </div>

        <div>Fraud Score: {{ order.FraudScore | float }}</div>

        <div style="text-transform: capitalize;">Fulfillment Status: {{ orderStatus }}</div>
      </div>

      <div class="flex flex-col col-span-1 gap-y-3">
        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.ZoneRelease)"
            class="form-checkbox checkbox"
            disabled
          />
          Zone Release
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.LocalSortText2)"
            class="form-checkbox checkbox"
            disabled
          />
          Is This a Gift?
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.LocalSortInteger3)"
            class="form-checkbox checkbox"
            disabled
          />
          TrustPilot Email Sent
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.LocalSortInteger4)"
            class="form-checkbox checkbox"
            disabled
          />
          Block Future Shipping
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.LocalSortInteger2)"
            class="form-checkbox checkbox"
            disabled
          />
          Ignore Fraud Score
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.Priority)"
            class="form-checkbox checkbox"
            disabled
          />
          Priority
        </div>

        <div>
          <input
            type="checkbox"
            :checked="isChecked(order.DoNotAdvertise)"
            class="form-checkbox checkbox"
            disabled
          />
          Do Not Advertise
        </div>
      </div>

      <div class="flex flex-col col-span-1 gap-y-3">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Gift Message
        </h3>
        <textarea
          class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 resize-none"
          rows="8"
          disabled
          v-text="order.GiftMessage"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/elements/Button";
import OrderMiscEditSlideover from "./slideovers/OrderMiscEdit";

export default {
  name: "OrderMisc",
  components: {
    Button,
    OrderMiscEditSlideover
  },
  filters: {
    float: val => {
      return parseFloat(val).toFixed(2);
    }
  },
  props: {
    order: {
      type: [Array, Object],
      required: true
    }
  },
  data() {
    return {
      showActionsMenu: false,
      slideoverTitle: "Title",
      slideoverVisible: false,
      slideoverProps: {},
      slideoverComponent: null
    };
  },
  computed: {
    orderStatus() {
      if (!this.order.status?.Status)
        return 'No Order Status Found';
      return this.order.status?.Status;
    },
    canShowActions() {
      if (this.order.status?.Status === 'Unprocessed') {
        return false
      }
      return true;
    },
  },
  methods: {
    isChecked(val) {
      if (
        val === null ||
        val === false ||
        val === 0 ||
        val === "0" ||
        String(val).trim() === "" ||
        String(val).toLowerCase().trim() === "no" ||
        val === [] ||
        val === {}
      )
        return false;
      return true;
    },
    showOrderMiscEditSlideover() {
      this.slideoverComponent = "OrderMiscEditSlideover";
      this.slideoverTitle = "Misc Edit";
      this.slideoverProps = {
        order: this.order
      };
      setTimeout(() => {
        this.slideoverVisible = true;
      }, 5);
    },
    hideSlideover() {
      this.slideoverVisible = false;
    },
    toggleActionsMenu() {
      this.showActionsMenu = !this.showActionsMenu;
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  @apply h-4 w-4 text-green-600 mr-2;
}
</style>
